import { useSearchParams } from "react-router-dom";

/**
 * Ultra-light i18n for public marketing pages.
 *
 * Usage:
 *   const lang = useLang();               // "en" | "fr"
 *   const label = t(lang, {en: "Home", fr: "Accueil"});
 *
 * The language is set purely from the `?lang=fr` (or `?lang=en`) URL param
 * so links can propagate it, and it defaults to English. Keeping it out of
 * localStorage means every share link is deterministic.
 */
export function useLang() {
  const [params] = useSearchParams();
  const v = (params.get("lang") || "en").toLowerCase();
  return v === "fr" ? "fr" : "en";
}

export function t(lang, dict) {
  if (!dict) return "";
  return dict[lang] ?? dict.en ?? "";
}

/** Build an href that preserves `?lang=fr` when the visitor is on the French site. */
export function withLang(path, lang) {
  if (lang !== "fr") return path;
  const [base, hash] = path.split("#");
  const [pathPart, query = ""] = base.split("?");
  const q = new URLSearchParams(query);
  q.set("lang", "fr");
  return `${pathPart}?${q.toString()}${hash ? `#${hash}` : ""}`;
}
